import { motion } from "framer-motion";
import { FiGlobe, FiUsers, FiAward, FiLayers, FiArrowRight, FiChevronRight } from "react-icons/fi";
import { FaStar } from 'react-icons/fa';
// import ExploreButton from '../UIVerse/ExploreButton';
import TechStack from '../../Components/TechStack/TechStack';
import FAQ from '../../Components/Faqs/Faqs';
import FeedbackCard from '../../Components/UIVerse/FeedbackCard'
import OurProcess from '../../Components/UIVerse/OurProcess'
import LogoSlider from "../UIVerse/logoSlider";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import caseStudies from "../../Pages/CaseStudy/CaseData";
import industries from "../../Data/industries";
import services from "../../Data/demo";
import { Helmet } from "react-helmet";

const HomePage = () => {

  const handleNavigate = (slug) => {
    navigate(`/industries/${slug}`, {
      state: { slug }
    });
  };
  const handleScroll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const navigate = useNavigate();
  // Features data
  const features = [
    {
      icon: <FiLayers className="w-6 h-6" />,
      title: "Full-Service Solutions",
      description: "End-to-end development from concept to deployment"
    },
    {
      icon: <FiUsers className="w-6 h-6" />,
      title: "Expert Team",
      description: "Seasoned professionals with diverse tech expertise"
    },
    {
      icon: <FiGlobe className="w-6 h-6" />,
      title: "Global Reach",
      description: "Serving clients worldwide with localized solutions"
    },
    {
      icon: <FiAward className="w-6 h-6" />,
      title: "Proven Results",
      description: "Award-winning projects with measurable impact"
    }
  ];

  // Services preview
  // const services = [
  //   {
  //     title: "Web Development",
  //     description: "Custom websites and web applications",
  //     icon: <FaLaptopCode className="w-10 h-10 text-purple-400" />
  //   },
  //   {
  //     title: "Mobile Apps",
  //     description: "iOS & Android development",
  //     icon: <FaMobileAlt className="w-10 h-10 text-purple-400" />
  //   },
  //   {
  //     title: "UI/UX Design",
  //     description: "User-centered interfaces",
  //     icon: <FaPaintBrush className="w-10 h-10 text-purple-400" />
  //   },
  //   {
  //     title: "Cloud Solutions",
  //     description: "Scalable infrastructure",
  //     icon: <FaCloud className="w-10 h-10 text-purple-400" />
  //   }
  // ];
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15
      }
    }
  };


  return (
    <div className="bg-gradient-to-br from-gray-900 to-blue-900">
      <Helmet>
        <title>Home - Digital Transformation Experts | Mern Digital</title>
        <meta name="description" content="Mern Digital is a full-service web development and digital marketing agency specializing in MERN stack development, custom website development,SEO, PPC, social media marketing, e-commerce solutions, and branding for businesses worldwide." />
        <link rel="canonical" href="https://merndigital.com" />
      </Helmet>
      {/* Hero Section */}
      <section className="relative overflow-hidden text-white min-h-auto flex pb-6 sm:pb-10">
        {/* Particle Background with improved animation */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(30)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              animate={{
                opacity: [0, 0.3, 0],
                x: [0, Math.random() * 400 - 200],
                y: [0, Math.random() * 400 - 200]
              }}
              transition={{
                duration: Math.random() * 15 + 10,
                repeat: Infinity,
                repeatType: "reverse",
                delay: Math.random() * 5
              }}
              className="absolute w-1.5 h-1.5 bg-blue-400 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                filter: 'blur(1px)'
              }}
            />
          ))}
        </div>

        {/* Floating gradient blobs with improved motion */}
        <motion.div
          animate={{
            x: [0, 100, 0],
            y: [0, -50, 0],
            rotate: [0, 180],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "linear",
          }}
          className="absolute top-1/4 -left-40 w-96 h-96 bg-gradient-to-br from-blue-700/20 to-purple-700/20 rounded-full blur-3xl"
        />

        <motion.div
          animate={{
            y: [0, 60, 0],
            scale: [1, 1.1, 1]
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
          className="absolute bottom-1/3 -right-20 w-72 h-72 bg-gradient-to-br from-purple-700/20 to-pink-700/20 rounded-full blur-3xl"
        />

        {/* Content container */}
        <div className=" mx-3 sm:mx-auto  sm:w-[90%] px-2 py-2 relative z-10 mt-[1rem] sm:mt-[1rem]">
          <div className="flex items-center text-center">
            {/* Text content with enhanced animations */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, staggerChildren: 0.1 }}
              className="flex  flex-col justify-center items-center  mx-auto"
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="sm:text-[25px] text-blue-300 mb-4 font-medium "
              >
                Digital Transformation Agency
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-3xl md:text-5xl lg:text-6xl font-bold -mb-8 leading-tight"
              >
                <span>We are a</span>
                <h1 className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                 AI Powered Website Development & Digital Marketing Agency
                </h1>{' '}
                <br />
                {/* <motion.span
                  className="relative inline-block"
                  whileHover={{ scale: 1.05 }}
                >
                  That <span className="text-purple-300">Accelerate</span>
                </motion.span>{' '} */}
                {/* Your Business */}
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="text-sm sm:text-xl text-blue-100 mb-10 max-w-lg leading-relaxed "
              >
                We craft immersive digital experiences that drive engagement, conversion, and growth. Our full-service approach delivers measurable results.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="flex flex-row gap-2 sm:gap-4 sm:text-lg text-sm"
              >
                <motion.button
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0 8px 25px rgba(59, 130, 246, 0.5)",
                  }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    navigate('/quotation');
                    handleScroll();
                  }}
                  className="relative overflow-hidden group bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 sm:px-16 sm:py-2 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  <span className="relative z-10">Get Started</span>
                  <motion.span
                    className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    initial={{ opacity: 0 }}
                  />
                </motion.button>

                <motion.button
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0 8px 20px rgba(139, 92, 246, 0.3)"
                  }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => {
                    navigate('/work')
                    handleScroll();
                  }}
                  className="border border-white/30 text-white px-3 sm:px-4 py-4 rounded-full sm:font-semibold backdrop-blur-md hover:bg-white/10 transition-all duration-300 flex items-center gap-4"
                >
                  <span>Explore Our Work</span>
                  <FiArrowRight className="text-blue-400 text-xl transition-transform group-hover:translate-x-1" />
                </motion.button>
              </motion.div>

              {/* Trust indicators */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.8 }}
                className="sm:mt-12 mt-5 flex sm:flex-row  sm:items-center sm:gap-6 gap-4 "
              >
                <div className="flex items-center  sm:gap-2 flex-wrap">
                  <span className="sm:text-2xl text-[13px] font-bold text-blue-300">250+</span>
                  <div className="text-blue-100 text-[13px] sm:text-sm">Successful Projects</div>
                </div>
                <div className="flex items-center  sm:text-xl flex-wrap sm:gap-3">
                  <FaStar className="text-yellow-400 text-[13px] " />
                  <div className="text-blue-100 sm:text-xl text-[13px]">4.9/5 (120+ Reviews)</div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Clients Logo Cloud */}
      <LogoSlider />

      {/* Technologies Section */}
      <section className="py-10 mt-9">
        <TechStack />
      </section>

      {/* Features Section */}
      <section className="py-10 ">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4 text-gray-900">
              <span className="text-blue-600">Why Choose Our Solutions</span>
            </h2>
            <p className="text-xl text-white max-w-2xl mx-auto">
              We combine technical expertise with creative vision to deliver exceptional results
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 ">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{
                  y: -10,
                  scale: 1.03,
                  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                }}
                className="relative bg-slate-900 p-8 rounded-xl shadow-lg border border-blue-100 overflow-hidden group "
              >


                {/* Icon container with gradient border */}
                <div className="relative inline-flex justify-center items-center mb-6 ">
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full blur-md opacity-100 group-hover:opacity-100 transition-opacity"></div>
                  <div className="relative bg-black text-blue-500 rounded-full w-14 h-14 flex items-center justify-center text-2xl shadow-sm group-hover:text-purple-600 transition-colors">
                    {feature.icon}
                  </div>
                </div>

                <h3 className="text-2xl font-bold mb-3 text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-500 group-hover:to-purple-600 transition-all">
                  {feature.title}
                </h3>

                <p className="text-gray-300 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-blue-500 group-hover:to-purple-600 transition-colors">
                  {feature.description}
                </p>

                {/* Animated underline */}
                <div className="mt-4">
                  <div className="w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-500 group-hover:w-full transition-all duration-300"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-10 relative overflow-hidden bg-gray-900">
        {/* Background elements */}
        <div className="absolute inset-0 overflow-hidden -z-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full filter blur-3xl"></div>
        </div>

        <div className="container mx-auto px-6">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-20"
          >
            <h2 className="text-5xl font-bold mb-6">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400  animate-gradient-x">
                Our Services
              </span>
            </h2>
            <p className="text-xl text-white max-w-3xl mx-auto">
              Crafted solutions that transform your digital presence
            </p>
          </motion.div>

          {/* Services grid - Creative Card Design */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20"
          >
            {services.map((service) => (
              <motion.div
                key={service.slug}
                variants={itemVariants}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
                className="group relative"
              >
                <Link
                  to={`/services/${service.slug}`}
                  onClick={handleScroll}
                  className="block h-full"
                >
                  <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 h-full shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 dark:border-gray-700 group-hover:border-blue-200 dark:group-hover:border-blue-600 overflow-hidden">
                    {/* Decorative element */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-500/5 to-purple-500/5 rounded-bl-full"></div>

                    {/* Icon */}
                    <div className="relative z-10 w-14 h-14 bg-blue-100 dark:bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                      {service.icon && (
                        <div className="text-2xl text-blue-600 dark:text-blue-400">
                          {service.icon}
                        </div>
                      )}
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300 relative z-10">
                      {service.title}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-600 dark:text-gray-300 mb-6 relative z-10 line-clamp-3">
                      {service.briefDescription || service.description}
                    </p>

                    {/* CTA */}
                    <div className="flex items-center text-blue-600 dark:text-blue-400 font-semibold group-hover:translate-x-1 transition-transform duration-300 relative z-10">
                      Explore service
                      <FiChevronRight className="w-4 h-4 ml-2" />
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>

          {/* CTA with animated gradient border */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="text-center mt-20"
          > <Link onClick={handleScroll} to='/quotation'>
              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="relative inline-block"
              >
                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 animate-pulse opacity-75 -z-10"></div>
                <button className="relative bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all">
                  Start Your Project Today
                  <span className="absolute -right-2 -top-2 w-5 h-5 bg-yellow-400 rounded-full animate-ping opacity-75"></span>
                </button>
              </motion.div></Link>
          </motion.div>
        </div>
      </section>

      {/*Industry We Served*/}
      <section className="relative py-10 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="lg:overflow-hidden py-4">
        <h2 className="font-bold text-4xl xl:text-5xl 2xl:text-6xl tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-600 pb-1">
          <span className="inline-block">Industries We Serve</span>
        </h2>
      </div>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            
            {Object.values(industries).slice(0, 6).map((industry, index) => (
              <motion.div
                key={industry.slug}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true, margin: "-50px" }}
                whileHover={{ y: -10 }}
                className="group relative"
              >
                <div
                  onClick={() => {
                    handleNavigate(industry.slug);
                    handleScroll();
                  }}
                  className="relative h-full cursor-pointer"
                >
                  {/* Gradient overlay using brand colors */}
                  <div
                    className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500 rounded-2xl"
                    style={{
                      background: industry.brand.gradient,
                      mixBlendMode: 'soft-light'
                    }}
                  ></div>

                  {/* Main card with border using brand color */}
                  <div
                    className="relative h-full bg-gray-800/80 rounded-2xl overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-500"
                    style={{
                      border: `1px solid ${industry.brand.color}20` // 20% opacity
                    }}
                  >
                    {/* Background accent glow */}
                    <div
                      className="absolute -inset-2 opacity-0 group-hover:opacity-40 blur-md transition-opacity duration-500"
                      style={{
                        background: industry.brand.color
                      }}
                    ></div>

                    <div className="relative h-full p-8 flex flex-col items-center text-center z-10">
                      {/* Icon with gradient glow */}
                      <div className="relative mb-6">
                        <div
                          className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-20 blur-md transition-all duration-500"
                          style={{
                            background: industry.brand.color
                          }}
                        ></div>
                        <motion.div
                          whileHover={{ scale: 1.1, rotate: 5 }}
                          className="p-4 rounded-xl inline-flex backdrop-blur-sm border"
                          style={{
                            backgroundColor: `${industry.brand.color}15`,
                            borderColor: `${industry.brand.color}30`
                          }}
                        >
                          <industry.icon.reactIcons
                            style={{
                              color: industry.brand.color
                            }}
                            className="text-4xl"
                          />
                        </motion.div>
                      </div>

                      {/* Title with brand color accent */}
                      <h3
                        className="text-2xl font-bold mb-3"
                        style={{
                          background: `linear-gradient(to right, #fff, ${industry.brand.accent})`,
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent'
                        }}
                      >
                        {industry.title}
                      </h3>

                      <p className="text-gray-300 mb-6">{industry.summary}</p>

                      {/* Segment badge */}
                      <div
                        className="mb-6 px-3 py-1 text-xs font-medium rounded-full"
                        style={{
                          backgroundColor: `${industry.brand.color}15`,
                          color: industry.brand.accent,
                          border: `1px solid ${industry.brand.color}30`
                        }}
                      >
                        {industry.segment}
                      </div>

                      {/* Stats highlights */}
                      {/* <div className="grid grid-cols-3 gap-2 w-full mb-6">
                        {industry.hero.highlights.map((highlight, i) => (
                          <div 
                            key={i}
                            className="p-2 rounded-lg"
                            style={{
                              backgroundColor: `${industry.brand.color}10`,
                              border: `1px solid ${industry.brand.color}20`
                            }}
                          >
                            <div 
                              className="text-xl font-bold mb-1"
                              style={{ color: industry.brand.accent }}
                            >
                              {highlight.value}
                            </div>
                            <div className="text-xs text-gray-300">{highlight.label}</div>
                          </div>
                        ))}
                      </div> */}

                      {/* Learn more button */}
                      <div className="mt-auto pt-4 w-full">
                        <motion.div
                          whileHover={{ scale: 1.05 }}
                          className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full transition-all duration-300"
                          style={{
                            background: `linear-gradient(90deg, ${industry.brand.color}30, ${industry.brand.accent}20)`,
                            border: `1px solid ${industry.brand.color}30`,
                            color: industry.brand.accent
                          }}
                        >
                          <span className="text-sm font-medium">Explore solutions</span>
                          <FiArrowRight />
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
        {/* View More button */}
        {industries.length > 6 && (
          <div className="flex justify-center mt-10">
            <motion.button
              whileHover={{ scale: 1.05 }}
              onClick={() => {
                navigate("/industries");
                handleScroll();
              }}
              className="px-6 py-3 rounded-full font-medium text-white shadow-lg transition-all duration-300"
              style={{
                background:
                  "linear-gradient(90deg, #4f46e5 0%, #9333ea 100%)",
              }}
            >
              View More Industries
            </motion.button>
          </div>
        )}
      </section>

      {/*Case Study */}
      <section id="case-studies" className="py-10 bg-gray-900 text-gray-100">
        <div className="container mx-auto px-6">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1 bg-blue-900/30 text-blue-400 rounded-full text-sm font-semibold mb-4">
              Case Studies
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Our Impactful Work
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Explore how we've helped clients solve complex challenges
            </p>
          </div>

          {/* Case Study Previews */}
          <div className="grid md:grid-cols-2 gap-8">
            {caseStudies.map((study) => (
              <article
                key={study.id}
                className="group relative rounded-2xl overflow-hidden shadow-xl hover:shadow-blue-500/20 transition-all duration-300 hover:-translate-y-1"
                aria-labelledby={`case-study-${study.id}-title`}
              >
                {/* Image container with lazy loading and better aspect ratio */}
                <div className="aspect-w-16 aspect-h-9 overflow-hidden">
                  <img
                    src={study.coverImage}
                    alt=""
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                    decoding="async"
                  />
                </div>

                {/* Gradient overlay with better contrast */}
                <div
                  className="absolute inset-0 bg-gradient-to-t from-gray-900/95 via-gray-900/30 to-transparent"
                  aria-hidden="true"
                />

                {/* Content container with semantic markup */}
                <div className="absolute inset-0 flex flex-col justify-end p-6">
                  {/* Tags with better spacing and visibility */}
                  <div className="flex flex-wrap gap-2 mb-3">
                    {study.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-gray-800/90 text-gray-100 rounded-full text-xs font-medium backdrop-blur-sm hover:bg-gray-700/90 transition-colors"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  {/* Heading with proper semantic association */}
                  <h2
                    id={`case-study-${study.id}-title`}
                    className="text-2xl font-bold text-white mb-2 leading-tight"
                  >
                    {study.title}
                  </h2>

                  {/* Description with better readability */}
                  <p className="text-gray-200 mb-4 line-clamp-2">
                    {study.description}
                  </p>

                  {/* CTA with improved focus states */}
                  <Link onClick={handleScroll}
                    to={`/case-studies/${study.slug}`}
                    className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 rounded px-1 -ml-1"
                    aria-label={`Read case study: ${study.title}`}
                  >
                    Read Case Study
                    <FiArrowRight className="ml-2 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* View All Button */}
          <div className="text-center mt-12">
            <Link to="/case-studies" onClick={handleScroll} className="inline-flex items-center px-6 py-3 border border-gray-700 text-gray-300 hover:text-white hover:border-blue-500 rounded-full font-medium transition-all">
              View All Case Studies <FiArrowRight className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      

      {/* Process Section */}
      <OurProcess />

      {/* FAQs Section */}
      <section className="py-10">
        <FAQ />
      </section>

      {/*Testimonials*/}
      <section className="py-10 ">
        <FeedbackCard />
      </section>



      {/* CTA Section */}
      <section className="py-10  text-white">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Transform Your Digital Presence Today
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Let's build something extraordinary together.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to='/quotation' onClick={handleScroll}>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate('/quotation')}
                  className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold shadow-lg"
                >
                  Get Started
                </motion.button></Link>
              <Link to='/contact' onClick={handleScroll}>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate('/contact')}
                  className="border-2 border-white text-white px-8 py-4 rounded-full font-bold"
                >
                  Contact Our Team
                </motion.button></Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;